import type { QueryClient } from '@tanstack/react-query'
import type { User } from '@/types/api'
import { useSessionStore } from '@/store/session'

const PRIVATE_QUERY_PREFIX = ['private'] as const

/** Todas las consultas con datos de cuenta deben incluir al propietario. */
export function privateQueryKey(userId: number, resource: string, ...parts: readonly unknown[]) {
  return [...PRIVATE_QUERY_PREFIX, userId, resource, ...parts] as const
}

/**
 * Cancela y elimina datos privados. Cancelar antes de eliminar evita que una
 * respuesta iniciada por la cuenta anterior vuelva a llenar la caché.
 */
export async function discardPrivateSessionData(queryClient: QueryClient) {
  await queryClient.cancelQueries({ queryKey: PRIVATE_QUERY_PREFIX })
  queryClient.removeQueries({ queryKey: PRIVATE_QUERY_PREFIX })
}

export async function establishSession(queryClient: QueryClient, user: User, accessToken: string) {
  useSessionStore.getState().setSession(user, accessToken)
  await discardPrivateSessionData(queryClient)
}

export async function clearSession(queryClient: QueryClient) {
  useSessionStore.getState().clear()
  await discardPrivateSessionData(queryClient)
}
